import React from 'react';
import './Promo.css';

const Promo = () => {
  return (
    <section className="promo text-center">
      <div className="container">
        <h2 className="display-4">Inter Milan Football Club </h2>
        <p className="lead">
          Add Players
        </p>
      </div>
    </section>
  );
};

export default Promo;
